import { Component, OnInit, OnDestroy } from '@angular/core';
import { Project, Objective, Icons } from 'toolbandi-ui-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService, CrudService, MessageService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ObjectiveEditComponent } from '../objective-edit/objective-edit.component';

@Component({
	selector: 'app-objective-view',
	templateUrl: './objective-view.component.html',
	styleUrls: ['./objective-view.component.scss']
})
export class ObjectiveViewComponent implements OnInit, OnDestroy {

	project: Project;
	loading: boolean = false;
	objective: Objective;
	breadcrumb: Breadcrumb;

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private objectiveService: CrudService<Objective>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private projectService: CrudService<Project>,
		private router: Router
	) { }

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
		});
	}

	load(id: number): void {
		this.loading = true;
		this.objectiveService.getEntity(Objective, 'objective', id).subscribe(objective => {
			this.objective = objective;
			this.projectService.getEntity(Project, 'project', this.objective.projectid).subscribe(project => {
				this.project = project;
				this.loading = false;
				this.setBreadcrumb();
			});
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.objective'));
			this.objective = undefined;
			this.loading = false;
		});

	}

	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.project.company.name, url: '/company/view/' + this.project.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
			{ title: this.project.name, url: '/company/project/view/' + this.project.id, icon: Icons.PROJECT, icontooltip: 'labels.project' }
		];
		this.breadcrumb.title = { title: this.objective.name, icon: Icons.OBJECTIVE, param: '', icontooltip: 'labels.objective' };
	}

}
